import { TenantContext } from '@/components';
import { SortDirection } from '@/components/Table/types';
import { businessAreasRepo } from '@/constants/providers';
import { UserBusinessArea } from '@/modules/BusinessAreas/domain';
import { DataWithPagination } from '@/shared/types';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { BusinessAreasKey } from './keys';

type UseGetBusinessAreasByUserProps = {
  userId: number;
  pageNumber?: number;
  filter?: string;
  sortBy?: string;
  sortOrder?: SortDirection;
};

export const useGetBusinessAreasByUser = ({
  userId,
  pageNumber,
  filter,
  sortBy,
  sortOrder,
}: UseGetBusinessAreasByUserProps) => {
  const { currentSelectedTenant } = useContext(TenantContext);
  return useQuery<DataWithPagination<UserBusinessArea[]>>(
    [
      ...BusinessAreasKey.BY_USER_PAGED(userId, {
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      }),
      currentSelectedTenant?.id,
    ],
    () =>
      businessAreasRepo.getBusinessAreasByUser(
        userId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
    {
      cacheTime: 1000 * 60 * 5,
    },
  );
};
